import { useContext } from 'react'
import { ProfileContext } from 'contexts/profileContext'

export const useProfileContext = () => useContext(ProfileContext)
